export default __webpack_public_path__ + "static/media/i178hp.6c37dee4.webp";